angular
	.module("pulseApp")
	.config(function($stateProvider, $urlRouterProvider) {
		$stateProvider.state("results", {
			url: "/results?city&cat",
			controller: "ResultsCtrl as vm",
			templateUrl: "app/view/results/results.html",
		});
	})
	.controller("ResultsCtrl", function($scope, $firebaseArray, $stateParams) {
		var vm = this;
		var ref = firebase.database().ref("Providers");
		vm.filterResults = function() {
            vm.setMap();
			if (vm.category !== "ALL" && vm.city !== "ALL") {
				vm.results = _.filter(vm.data, {
					City: vm.city,
					Type: vm.category
				});
			} else if (vm.category === "ALL") {
				//All Cats
				vm.results = _.filter(vm.data, { City: vm.city });
			} else {
				vm.results = vm.data;
			}
		};
		vm.nameTypes  = [{
			abbr: 'F',
			name: 'Food'
		},
		{
			abbr: 'H',
			name: 'Housing'
		},
		{
			abbr: 'G',
			name: 'Government Services'
		},
		{
			abbr: 'E',
			name: 'Events'
		},
		{
			abbr: 'HE',
			name: 'Health'
		},
		{
			abbr: 'W',
			name: 'Work'
		},
		
		]
		
		vm.data = $firebaseArray(ref);
		vm.data.$loaded()
		.then(function(x) {
			for(var i = 0; i < vm.data.length; i++){
				if(vm.data[i].Reviews !== undefined && vm.data[i].Reviews !== null){
					vm.data[i].ReviewCount = Object.keys(vm.data[i].Reviews).length;
					vm.data[i].totalRating = 0;
					var type = _.find(vm.nameTypes, {'abbr': vm.data[i].Type});
					if(type !== undefined && type !== null){
						vm.data[i].TypeName = type.name;
						
					}
					console.log(vm.data[i].TypeName);
					for(var key in vm.data[i].Reviews) {
						var value = vm.data[i].Reviews[key];
						vm.data[i].totalRating = vm.data[i].totalRating + value.Stars;
						// do something with "key" and "value" variables
					  }
					  vm.data[i].avgRating = vm.data[i].totalRating /vm.data[i].ReviewCount;
					  
					 }
				else{
					vm.data[i].ReviewCount = 0;
				}
				
			}
			vm.filterResults();
			
		})
		.catch(function(error) {
		  console.log("Error:", error);
		});
		vm.rating = 4;

        vm.city = $stateParams.city;
        vm.cityInfo = [];
        vm.setMap = function(){
        vm.cityInfo = _.filter(vm.cities, { abbr: vm.city})
        }
        vm.setMap();
		vm.category = $stateParams.cat;
		vm.cities = [
			{
				cords: "40.760779, -111.891047",
				name: "Salt Lake City",
				abbr: "SLC"
            },
            {
				cords: "47.606209, -122.332071",
				name: "Seattle",
				abbr: "SEA"
            },
            {
				cords: "32.715738, -117.161084",
				name: "San Diego",
				abbr: "SD"
            },
            {
				cords: "45.523062, -122.676482",
				name: "Portland",
				abbr: "P"
            }            ,
            {
				cords: "36.169941, -115.13983",
				name: "Las Vegas",
				abbr: "LV"
			},
            {
				cords: "37.774929, -122.419416",
				name: "San Fransico",
				abbr: "SF"
            },
            {
                cords: "34.052234, -118.243685",
				name: "Los Angeles",
				abbr: "LA" 
            }
		];





		vm.results = [];

		



        
		
		vm.getId = function(index) {
			return vm.results.$keyAt(index);
		};
		var destroy = $scope.$on("$destroy", function() {
			//Cleanup anything that would persist beyond destruction, including $on/$watch
			destroy();
		});
	});
